/* eslint-disable no-unused-vars */
export enum ActiveState {
  OFF = 'off',
  ON = 'on',
}
